import { render, staticRenderFns } from "./listaClientes_new.vue?vue&type=template&id=3e676227"
import script from "./listaClientes_new.vue?vue&type=script&lang=js"
export * from "./listaClientes_new.vue?vue&type=script&lang=js"
import style0 from "./listaClientes_new.vue?vue&type=style&index=0&id=3e676227&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports